import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const RequestApproval = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "request-approval" */ './hocs')),
});
